import { utils } from '@easydata/core';
/**
 * Represents a widget - a visual element with "knows" how to render itself.
 * Some widgets just display some information from the context (like the generated SQL or the result set).
 * Others - allow user to interact with them to define query conditions or columns.
 */
var Widget = /** @class */ (function () {
    /**
     Initializes a new instance of the `Widget` class
     * @param slot - an HTML element in which we should place our widget.
     */
    function Widget(slot) {
        this.slot = slot;
        this._id = utils.generateId(this.getWidgetType());
    }
    Object.defineProperty(Widget.prototype, "id", {
        get: function () {
            return this._id;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Initializes the widget and assign it to some context
     * @param context
     * @param options
     */
    Widget.prototype.init = function (context, options) {
        this.context = context;
    };
    /**
     * Returns current context (the one this widget belongs to)
     */
    Widget.prototype.getContext = function () {
        return this.context;
    };
    /**
     * Refreshes the widget's content
     */
    Widget.prototype.refresh = function () {
        this.refreshCore();
    };
    /**
     * This function is called from `refresh` function.
     * It does nothing in the base `Widget` class
     * but can be overridden in derived classes
     * to implement the functionality specific for a particular widget
     */
    Widget.prototype.refreshCore = function () {
    };
    /**
     * This function is called on the start of some process this widget participates in.
     * For example, some widgets can show a spinner or a progress bar
     * at the beginning of some long process (e.g. model loading).
     */
    Widget.prototype.onProcessStart = function () {
        this.onProcessStartCore();
    };
    /**
     * This function is called from `onProcessStart` function.
     * It does nothing in the base `Widget` class
     * but can be overridden in derived classes
     * to implement the functionality specific for a particular widget.
     */
    Widget.prototype.onProcessStartCore = function () {
    };
    /**
     * This function is called on the end of some process this widget participates in.
     * For example, some widgets should be updated on model loading
     * or after the execution of the current query
     */
    Widget.prototype.onProcessEnd = function () {
        this.onProcessEndCore();
    };
    /**
     * This function is called from `onProcessEnd` function.
     * It does nothing in the base `Widget` class
     * but can be overridden in derived classes
     * to implement the functionality specific for a particular widget.
     */
    Widget.prototype.onProcessEndCore = function () {
    };
    /**
     * Returns `true` if the widget belongs to one of the groups specified in the parameter
     * @param groups
     */
    Widget.prototype.belongsToGroup = function (groups) {
        if (typeof groups != 'undefined' && groups != null) {
            if ((groups & this.group) === 0)
                return false;
        }
        return true;
    };
    Widget.prototype.destroy = function () {
        this.destroyCore();
    };
    Widget.prototype.destroyCore = function () {
    };
    return Widget;
}());
export { Widget };
//# sourceMappingURL=widget.js.map